import { LitElement, mailcheck, intlTelInput, countryTranslations } from '@hh/global.js'

class OmetriaProfile extends LitElement {
  static properties = {
    initCountry: {
      type: String,
      attribute: 'init-country',
    },
  }

  constructor() {
    super()
    this.form = this.querySelector('form')
    if (!this.form) return
    this.form.addEventListener('submit', this.submitForm.bind(this))

    this.isSubmitted = false
    this.submitButton = this.querySelector('[type="submit"]')
    this.errorBanner = this.querySelector('.js-error-banner')

    this.firstNameInput = this.querySelector('[name="firstname"]')
    this.lastNameInput = this.querySelector('[name="lastname"]')
    this.emailInput = this.querySelector('[name="email"]')
    this.phoneInput = this.querySelector('[name="phone_input"]')
    this.consentInput = this.querySelector('[name="consent"]')
    this.consentSMSInput = this.querySelector('[name="sms_optin"]')
    this.consentEmailInput = this.querySelector('[name="marketing_optin"]')
    this.consentSMSCheckbox = this.querySelector('[name="sms_optin_checkbox"]')
    this.consentEmailCheckbox = this.querySelector('[name="marketing_optin_checkbox"]')
    this.emailSuggestion = this.querySelector('.js-email-suggestion')
  }

  connectedCallback() {
    this.firstNameInput.addEventListener('input', (e) =>
      this.validateInput(this.firstNameInput, 'First Name')
    )
    this.lastNameInput.addEventListener('input', (e) =>
      this.validateInput(this.lastNameInput, 'Last Name')
    )
    this.emailInput.addEventListener('input', (e) =>
      this.validateInput(this.emailInput, 'Email')
    )
    this.consentInput.addEventListener('input', (e) =>
      this.validateInput(this.consentInput, 'Consent')
    )
    this.consentSMSCheckbox?.addEventListener('input', (e) =>
      this.validateInput(this.consentSMSCheckbox, 'ConsentSMS')
    )
    this.consentEmailCheckbox?.addEventListener('input', (e) =>
      this.validateInput(this.consentEmailCheckbox, 'ConsentEmail')
    )

    this.phoneNumber = intlTelInput(this.phoneInput, {
      initialCountry: window.Shopify.country,
      nationalMode: true,
      loadUtilsOnInit: "https://cdn.jsdelivr.net/npm/intl-tel-input@24.7.0/build/js/utils.js",
      autoPlaceholder: "off"
    });
  }

  disconnectedCallback() {
    this.firstNameInput.removeEventListener('input', (e) =>
      this.validateInput(this.firstNameInput, 'First Name')
    )
    this.lastNameInput.removeEventListener('input', (e) =>
      this.validateInput(this.lastNameInput, 'Last Name')
    )
    this.emailInput.removeEventListener('input', (e) =>
      this.validateInput(this.this.validateInput(this.emailInput, 'Email'))
    )
    this.consentInput.removeEventListener('input', (e) =>
      this.validateInput(this.consentInput, 'Consent')
    )
    this.consentSMSCheckbox?.removeEventListener('input', (e) =>
      this.validateInput(this.consentSMSCheckbox, 'ConsentSMS')
    )
    this.consentEmailCheckbox?.removeEventListener('input', (e) =>
      this.validateInput(this.consentEmailCheckbox, 'ConsentEmail')
    )
  }

  validateInput(element, field) {
    if (field === 'Consent') {
      if (element.checked) {
        element.parentNode.classList.remove('error')
      } else {
        element.parentNode.classList.add('error')
        this.errorBanner.textContent =
          "Please accept the Privacy Policy and T&C's to continue"
      }
    } else if (field === 'ConsentSMS' && element.hasAttribute('data-required')) { 
      if (element.checked) {
        element.parentNode.classList.remove('error')
      } else {
        element.parentNode.classList.add('error')
        this.errorBanner.textContent =
          "Please agree to receive marketing SMS messages to continue"
      }
    } else if (field === 'ConsentEmail' && element.hasAttribute('data-required')) {  
      if (element.checked) {
        element.parentNode.classList.remove('error')
      } else {
        element.parentNode.classList.add('error')
        this.errorBanner.textContent =
          "Please agree to receive marketing emails to continue"
      }
    } else if (element.id === 'ModalForm-Email') {
      if (!element.value.trim()) {
        element.parentNode.classList.add('error')
        this.errorBanner.textContent = `${field} is required`
      } else if (!this.validateEmail(element.value)) {
        element.parentNode.classList.add('error')
        this.errorBanner.textContent = `Invalid Email`
      } else {
        element.parentNode.classList.remove('error')
      }
    } else if (field === 'Phone') {
      if (this.phoneInput.getAttribute('required') === 'true') {
        element.classList[this.phoneNumber.isValidNumber() ? 'remove' : 'add']('error')
        if (!this.phoneNumber.isValidNumber()) {
          this.errorBanner.textContent = `Valid ${field} is required`
        }
      }
    } else {
      if (!element.value.trim()) {
        element.parentNode.classList.add('error')
        this.errorBanner.textContent = `${field} is required`
      } else {
        element.parentNode.classList.remove('error')
      }
    }

    this.errorCount = 0
    this.querySelectorAll(
      '.newsletter-form__input, .newsletter-form__checkbox'
    ).forEach((input) => {
      if (input.classList.contains('error')) {
        this.errorCount++
      }
    })

    if (this.errorCount === 0) {
      this.hideStatus()
    }
  }

  validateEmail = (email) => {
    const re = /\S+@\S+\.\S+/
    return re.test(email)
  }

  getBirthday = (year, month, day) => {
    const paddedMonth = month.toString().padStart(2, '0')
    const paddedDay = day.toString().padStart(2, '0')
    return `${paddedMonth}-${paddedDay}-${year}`
  }

  submitForm(event) {
    event.preventDefault()
    this.hideStatus()

    this.isSubmitted = true
    this.validateInput(this.firstNameInput, 'Firt Name')
    this.validateInput(this.lastNameInput, 'Last Name')
    this.validateInput(this.emailInput, 'Email')
    this.validateInput(this.consentInput, 'Consent')
    this.validateInput(this.phoneInput, 'Phone')

    if (this.consentSMSCheckbox) {
      this.validateInput(this.consentSMSCheckbox, 'ConsentSMS')
    }

    if (this.consentEmailCheckbox) { 
      this.validateInput(this.consentEmailCheckbox, 'ConsentEmail')
    }

    this.hasError = false
    this.errorCount = 0

    this.querySelectorAll(
      '.newsletter-form__input, .newsletter-form__checkbox'
    ).forEach((input) => {
      if (input.classList.contains('error')) {
        this.hasError = true
        this.errorCount++
      }
    })

    if (this.hasError) {
      if (this.errorCount > 1) {
        this.errorBanner.textContent = 'Please fill out all required fields'
      }
      this.showError()
      return
    }

    this.hideStatus()

    const email = this.emailInput.value

    mailcheck.run({
      email,
      suggested: (suggestion) => {
        this.emailSuggestion.querySelector('.js-email').innerHTML = `${suggestion.address}@<strong>${suggestion.domain}</strong>`
        this.emailSuggestion.removeAttribute('hidden')
      },
      empty: () => {
        this.createAccount()
      }
    })
  }

  async createAccount() {
    const formData = new FormData(this.form)
    const email = formData.get('email')
    const countryName = formData.get('country_name')

    const countryTranslation = Object.keys(countryTranslations).map(code => ({
      code: code,
      label: countryTranslations[code]
    })).find(translation => countryName === translation.label)

    this.emailInput.value = null
    this.querySelector('[name="ue"]').value = email
    this.querySelector('[name="phone_number"]').value = this.phoneNumber.getNumber()
    this.querySelector('[name="country_id"]').value = countryTranslation?.code

    if (this.consentSMSInput && this.consentSMSCheckbox) {
      this.consentSMSInput.value = this.consentSMSCheckbox.checked ? 'true' : 'false'
    }
    
    if (this.consentEmailInput && this.consentEmailCheckbox) {
      this.consentEmailInput.value = this.consentEmailCheckbox.checked ? 'true' : 'false'
    }    

    this.dispatchEvent(
      new CustomEvent('profileModalSuccess', { bubbles: true })
    )

    this.form.submit()
  }

  showError() {
    this.errorBanner?.removeAttribute('hidden')
  }

  hideStatus() {
    // this.successBanner?.setAttribute('hidden', true)
    this.errorBanner?.setAttribute('hidden', true)
    this.emailSuggestion?.setAttribute('hidden', true)
  }
}

customElements.define('hh-ometria-profile', OmetriaProfile)
